var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Completed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed",
    clipPath: "url(#clip-Completed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    transform: "translate(1 1)",
    fill: "#8bc400",
    stroke: "#8bc400",
    strokeWidth: 1.2,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "completed-task",
    transform: "translate(-82.003 -54.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19554",
    "data-name": "Path 19554",
    d: "M107.3,82.5H94.57c-.009,0-.019-.014-.028-.019A1.376,1.376,0,0,1,93.4,81V66.176A1.377,1.377,0,0,1,94.876,64.7h12.132a1.444,1.444,0,0,1,.84.228,1.422,1.422,0,0,1,.622,1.268q-.007,7.4,0,14.806a2.062,2.062,0,0,1-.019.292,1.3,1.3,0,0,1-.72,1.04A2.9,2.9,0,0,1,107.3,82.5ZM94.788,66.074V81.117h12.29V66.074Z",
    transform: "translate(0 0)",
    fill: "#96b547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19555",
    "data-name": "Path 19555",
    d: "M123.3,94.3h12.29v15.043H123.3Zm4.81,5.223c-.33-.33-.608-.613-.891-.891a.685.685,0,1,0-.97.966c.441.446.882.887,1.328,1.323a.812.812,0,0,0,.339.2.708.708,0,0,0,.715-.241q1.978-1.985,3.965-3.97c.046-.046.088-.093.13-.139a.675.675,0,0,0-.33-1.059.7.7,0,0,0-.743.2q-1.72,1.72-3.436,3.44A.745.745,0,0,0,128.11,99.523Zm.659,3.668h-3.3a1.771,1.771,0,0,0-.274.019.673.673,0,0,0-.52.813.7.7,0,0,0,.761.543h6.546a1.881,1.881,0,0,0,.228,0,.676.676,0,0,0,.655-.659.684.684,0,0,0-.743-.71Zm-1.7,2.735c-.562,0-1.124,0-1.685,0a.686.686,0,1,0-.014,1.37c1.124,0,2.247,0,3.366,0a.688.688,0,0,0,.659-.933.675.675,0,0,0-.65-.436C128.189,105.926,127.627,105.93,127.065,105.926Z",
    transform: "translate(-28.512 -28.226)",
    fill: "#f3ffd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19556",
    "data-name": "Path 19556",
    d: "M184.154,127.55a1.052,1.052,0,0,1,.111-.176q1.72-1.72,3.436-3.44a.685.685,0,0,1,.743-.2.678.678,0,0,1,.33,1.059.926.926,0,0,1-.13.139c-1.323,1.323-2.646,2.642-3.965,3.97a.7.7,0,0,1-.715.241.792.792,0,0,1-.339-.2c-.45-.436-.887-.878-1.328-1.323a.685.685,0,1,1,.97-.966C183.545,126.937,183.829,127.22,184.154,127.55Z",
    transform: "translate(-84.555 -56.252)",
    fill: "#96b547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19557",
    "data-name": "Path 19557",
    d: "M156.65,285.8H160a.686.686,0,1,1,.088,1.37c-.074,0-.149,0-.228,0h-6.546a.7.7,0,0,1-.761-.543.678.678,0,0,1,.52-.812,1.361,1.361,0,0,1,.274-.019Z",
    transform: "translate(-56.392 -210.835)",
    fill: "#96b547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19558",
    "data-name": "Path 19558",
    d: "M155,344.658c.562,0,1.124,0,1.685,0a.681.681,0,0,1,.65.436.656.656,0,0,1-.158.734.675.675,0,0,1-.5.2c-1.124,0-2.247,0-3.366,0a.686.686,0,1,1,.014-1.37Z",
    transform: "translate(-56.45 -266.958)",
    fill: "#96b547"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedActive);
export default __webpack_public_path__ + "static/media/Completed_Active.1b2926a4eb5a2b8243d93b71ca47bd84.svg";
export { ForwardRef as ReactComponent };